import { Component, Output, EventEmitter, Input } from '@angular/core'
import { planChangeSummaryPath } from 'src/utils'
import { Customer } from 'src/types'
import get from 'lodash-es/get'

@Component({
  selector: 'video-info-modal',
  styles: [`
    h3 {
      height: 24px;
      line-height: 24px;
    }
    h3 span {
      vertical-align: middle;
    }

    #video-frame {
      width: 100%;
      height: 315px;
      max-width: 560px;
    }
  `],
  template: `
    <modal width="600" (outsideClick)="close.emit()">
      <h4 class="small-top-buffer">
        Video + Written Content = The SEO Edge
      </h4>
      <hr class="brand-hr"/>
      <p class="h4-subheader">
        Add more channels to your SEO arsenal.
        Amplify on social media or share on your website.
        Verblio Vids are the multimedia key to diversify the ways your audience can consume written content you've published, and increase your SEO.
        Amplify on social media or embed in your content.
      </p>
      <!-- Don't show if signing up -->
      <ng-template [ngIf]="showAddVideo">
        <h5 class="mt-2">Two ways to add video</h5>
        <ol>
          <li>Select "Add a Video" whenever you accept content</li>
          <li>or, <a [href]="plusVideoPlanChange">Update your subscription</a> and save $10 each by adding the power of video to every piece you purchase</li>
        </ol>
      </ng-template>
      <div class="top-buffer">
        <h4>Sample Video</h4>
        <embed-video></embed-video>
      </div>
      <div class="mt-3">
        <div class="d-flex flex-row align-items-center justify-content-between">
          <div>
            <button class="secondary-outline-button" (click)="close.emit()">Close</button>
            <button *ngIf="showAddVideo" class="btn btn-secondary ml-2" (click)="navigateToPlusVideoPlanChange()">Add videos to my subscription</button>
          </div>
          <div>
          <a href="https://help.verblio.com/pro-services-and-products/how-to-receive-videos-with-your-purchased-content" target="_blank">Learn more</a>
          </div>
        </div>
      </div>
    </modal>
  `
})
export class VideoInfoModal {
  @Input() price: string
  @Input() customer: Customer
  @Output() close: EventEmitter<null> = new EventEmitter<null>();
  exampleVideoVisible: boolean = false;

  get plusVideoPlanChange(): string {
    return planChangeSummaryPath({
      customer: this.customer,
      options: [...get(this.customer, 'subscription.planAddOns', []).map(pao => pao.code), 'option-h']
    })
  }

  get showAddVideo(): boolean {
    return get(this.customer, 'subscription.state') === 'active' &&
    !get(this.customer, 'subscription.planAddOns', []).find(a => a.code === 'option-h')
  }

  navigateToPlusVideoPlanChange(): void {
    const url = this.plusVideoPlanChange
    window.location.assign(url)
  }
}
